export default {
  showOnlyAvailableApps: 'Zobraziť iba dostupné aplikácie',
};
